var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.32422 13.1783L2.45922 12.6256C2.58322 12.1171 3.72922 7.65778 5.73722 7.65778C6.21872 7.65778 6.68989 7.90911 7.13755 8.40444C7.70789 9.03561 7.89489 9.67128 7.69355 10.2944C7.10805 12.1061 3.31172 12.9669 2.88089 13.0593L2.32422 13.1783ZM5.73722 8.37194C4.75872 8.37194 3.79955 10.5378 3.30805 12.2186C4.57972 11.8718 6.68272 11.1006 7.01405 10.0746C7.13255 9.70694 6.99972 9.31728 6.60755 8.88328C6.30089 8.54428 6.00822 8.37194 5.73722 8.37194Z",
    fill: "#2A7F77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.32336 9.83682L7.1232 9.35382C6.89536 8.80382 6.19853 8.43899 6.19153 8.43532L5.7627 8.21815L12.5692 1.07599L14.4672 2.97399L7.32336 9.83682ZM6.9112 8.04866C7.1062 8.19149 7.33986 8.39282 7.5312 8.64682L13.4469 2.96366L12.5817 2.09832L6.9112 8.04866Z",
    fill: "#2A7F77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.0508 15.6H15.1508V15.5V4.137V4.037H15.0508H14.3366H14.2366V4.137V14.6858H0.864948V1.31417H11.3456H11.4456V1.21417V0.5V0.4H11.3456H0.0507812H-0.0492188V0.5V15.5V15.6H0.0507812H15.0508Z",
    fill: "#2A7F77",
    stroke: "black",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushGreen);
export default __webpack_public_path__ + "static/media/brushGreen.6cdafa7c6bf8262989a34af079772745.svg";
export { ForwardRef as ReactComponent };